import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { SearchService } from '../../../../services/search.service';
import { AuthService } from '../../../../services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/shared/services/rest.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { SignalRService } from 'src/app/shared/services/signal-r.service';
import { NotificationsDto } from 'src/app/shared/models/notificationDtos/NotificationsDto';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PermissionService } from 'src/app/shared/services/permission.service';

@Component({
  selector: 'app-header-sidebar-large',
  templateUrl: './header-sidebar-large.component.html',
  styleUrls: ['./header-sidebar-large.component.scss']
})
export class HeaderSidebarLargeComponent implements OnInit {
  @ViewChild('detailsModal') popupTemplate;
  @ViewChild('GroupTaskdetailsModal') GroupTaskdetailsTemplate;

  notifications: any[];
  currentUser: any;
  User: any;
  loader: boolean;
  initials: any;
  languages: any;
  defaultLanguage: any = "ar";
  selectedLanguage: any;
  loading: boolean;
  dropdownItems: []
selectedItem: any;
  constructor(
    private navService: NavigationService,
    public searchService: SearchService,
    private auth: AuthService,
    private userService: UserService,
    private store: LocalStoreService,
    private translate: TranslateService,
    private restService: RestService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    public signalRService: SignalRService,
    private router: Router,
    private location: Location,
    private renderer: Renderer2,
    private permissionService: PermissionService
  ) {
    this.notifications = [
      {
        icon: 'i-Speach-Bubble-6',
        title: 'New message',
        badge: '3',
        text: 'James: Hey! are you busy?',
        time: new Date(),
        status: 'primary',
        link: '/chat'
      },
      {
        icon: 'i-Receipt-3',
        title: 'New order received',
        badge: '$4036',
        text: '1 Headphone, 3 iPhone x',
        time: new Date('11/11/2023'),
        status: 'success',
        link: '/tables/full'
      },
      {
        icon: 'i-Empty-Box',
        title: 'Product out of stock',
        text: 'Headphone E67, R98, XL90, Q77',
        time: new Date('11/10/2023'),
        status: 'danger',
        link: '/tables/list'
      },
      {
        icon: 'i-Data-Power',
        title: 'Server up!',
        text: 'Server rebooted successfully',
        time: new Date('11/08/2023'),
        status: 'success',
        link: '/dashboard/v2'
      },
      {
        icon: 'i-Data-Block',
        title: 'Server down!',
        badge: 'Resolved',
        text: 'Region 1: Server crashed!',
        time: new Date('11/06/2023'),
        status: 'danger',
        link: '/dashboard/v3'
      }
    ];
  }

  async ngOnInit() {
    try {
      // First, get current user and store permissions
      await this.getCurrentUser();

      // Force navigation menu refresh after permissions are loaded
      this.navService.refreshMenu();

      // Then initialize other services that depend on permissions
      this.getLanguages();
      this.setupSignalR();
      this.loadNotifications();
      this.loadDropdown();

    } catch (error) {
      console.error('Error during component initialization:', error);
      // Handle error appropriately
    }
  }

  getCurrentUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.loader = true;
      this.userService.getUserInfo().subscribe(
        (resp: any) => {
          console.log('User response:', resp); // Debug log

          // Check the actual structure of the response
          let permissions = null;
          let userData = null;

          if (resp && resp.result) {
            // If response has result wrapper
            permissions = resp.result.permissions;
            userData = resp.result;
          } else if (resp && resp.permissions) {
            // If response is direct user object
            permissions = resp.permissions;
            userData = resp;
          } else {
            console.error('Unexpected response structure:', resp);
            this.loader = false;
            reject(new Error('Invalid user data structure'));
            return;
          }

          // Store permissions if they exist
          if (permissions) {
            this.permissionService.storePermissions(permissions);
            this.store.setItem('permissions', permissions);
          } else {
            console.warn('No permissions found in user response');
          }

          // Set user data
          this.User = userData;
          if (userData && userData.fullName) {
            this.initials = userData.fullName.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase();
          }

          this.loader = false;
          resolve(resp);
        },
        error => {
          console.error('Error getting user info:', error);
          this.loader = false;
          reject(error);
        }
      );
    });
  }

  private setupSignalR() {
    this.signalRService.startConnection();
    this.signalRService.addDataListener('UpdateWorkOrderInDispatchBoard').subscribe((mockElement) => {
      this.signalRService.signalrNotifications.unshift({
        icon: 'fontAwesome_Li_Class fa fa-3x fa-shopping-basket',
        title: mockElement.title,
        badge: mockElement.statusText,
        text: mockElement.description,
        time: mockElement.creationTime,
        status: mockElement.statusText,
        link: mockElement.link,
        isRead: mockElement.isRead,
        id: mockElement.id,
        sourceId: '101',
        sourceType: mockElement.sourceType,
        taskGroupId: '5'
      });
    });
  }

  private loadNotifications() {
    let url = environment.urls.Notification_GET_ALL;
    this.restService.getWithoutLoader(url).subscribe(res => {
      this.signalRService.signalrNotifications = [];
      res.result.items.forEach(element => {
        if (!element.status) {
          element.statusText = 'Completed';
        }

        this.signalRService.signalrNotifications.push({
          icon: 'fontAwesome_Li_Class fa fa-3x fa-shopping-basket',
          title: element.title,
          badge: element.statusText,
          text: element.description,
          time: element.creationTime,
          status: element.statusText,
          link: element.link,
          isRead: element.isRead,
          id: element.id,
          sourceId: element.sourceId,
          sourceType: element.sourceType,
          taskGroupId: element.taskGroupId
        });
      });
    });
  }

  public sourceId = '';
  public isTaskGroup = false;

  readNotification(notification: NotificationsDto) {
    let url = environment.urls.Notification_Update_Notification;
    this.restService.post(url, notification).subscribe(res => {
      var notificationIndex = this.signalRService.signalrNotifications.findIndex(x => x.id == notification.id);
      this.signalRService.signalrNotifications.splice(notificationIndex, 1);

      if (notification.link) {
        this.router.navigateByUrl(notification.link);
      }
    });
  }

  toggelSidebar() {
    const state = this.navService.sidebarState;

    // Case 1: Both are open, close child only
    if (state.childnavOpen && state.sidenavOpen) {
      state.childnavOpen = false;
      this.addSidebarOpenAndCloseClass();
      return;
    }

    // Case 2: Only sidebar is open, close sidebar
    if (!state.childnavOpen && state.sidenavOpen) {
      state.sidenavOpen = false;
      this.addSidebarOpenAndCloseClass();
      return;
    }

    // Case 3: Both are closed, selected item has child items
    if (!state.sidenavOpen && !state.childnavOpen && this.navService.selectedItem?.type === 'dropDown') {
      state.sidenavOpen = true;
      setTimeout(() => {
        state.childnavOpen = true;
      }, 50);
      this.addSidebarOpenAndCloseClass();
      return;
    }

    // Case 4: Both are closed, selected item has no children
    if (!state.sidenavOpen && !state.childnavOpen) {
      state.sidenavOpen = true;
      this.addSidebarOpenAndCloseClass();
    }
  }

  addSidebarOpenAndCloseClass() {
    const state = this.navService.sidebarState;
    let mainHeaderElement = this.renderer.selectRootElement('.main-content-wrap', true);
    let querySelector = mainHeaderElement;

    if (querySelector) {
      if (!state.sidenavOpen) {
        querySelector.classList.remove('sidenav-open');
        querySelector.classList.add('sidenav-icons-open');
      } else {
        querySelector.classList.remove('sidenav-icons-open');
        querySelector.classList.add('sidenav-open');
      }
    } else {
      console.error('.main-header element not found');
    }
  }

  signout() {
    this.auth.signout();
  }

  getLanguages() {
    this.languages = this.store.getItem("languages");

    for (let i = 0; i < this.languages?.length; i++) {
      const lang = this.languages[i];
      if (lang.name === this.store.getItem('defaultLanguage')) {
        this.selectedLanguage = lang.displayName;
        break;
      }
    }
  }

  changeLanguage(language: any): void {
    this.loaderService.setIsLoading(true);

    this.defaultLanguage = language.name;

    this.loading = true;
    this.restService.get(`${environment.urls.Get_All_Language_Text}?source=${language.name}&languageName=${language.displayName}`)
      .subscribe((response) => {
        if (response.result.length > 0) {
          this.selectedLanguage = language.displayName;

          let translationsData = {} as any;

          response?.result?.forEach((translationText: any) => {
            translationsData[translationText?.key] = translationText.value;
          });

          this.translate.setTranslation(this.defaultLanguage, translationsData);
          this.translate.setDefaultLang(this.defaultLanguage);

          this.store.setItem('languageTexts', translationsData);
          this.store.setItem('defaultLanguage', this.defaultLanguage);
          this.store.setItem('defaultLangId', language.id);

          this.loaderService.setIsLoading(false);
          this.loading = false;
        } else {
          this.loaderService.setIsLoading(false);
          this.loading = false;
          this.toastr.error(`No data found for : ${language.displayName}`);
        }
      });
  }

  loadDropdown() {
    this.restService.getExternal(`${environment.apiBaseUrl2}/DatabaseSwitch/environments`)
      .subscribe((res: any) => {
        if (res && res.success && res.result) {
          this.dropdownItems = res.result.map((item: string) => ({ name: item }));
        }
      });
  }

 onSelect(env: any) {
  const envName = env?.name || env; // make sure we always send the string
  console.log("Selected environment:", envName);

  this.restService.postExternal(
    `${environment.apiBaseUrl2}/DatabaseSwitch/switch-environment/${envName}`,
    {} // empty body
  )
  .subscribe(() => {
    this.toastr.info(`Sign in to ${envName} to continue.`);
    this.auth.signout();
  });
}

}